const LEGACY_PASSKEY_BY_EMAIL_KEY = "mobsuccess.auth.passkeyHint.v1";
const LEGACY_DEVICE_PASSKEY_STORAGE_KEY = "mobsuccess.auth.devicePasskey.v1";

/** Last email used on this device (cleared on sign-out). */
const LAST_LOGIN_EMAIL_STORAGE_KEY = "mobsuccess.auth.lastLoginEmail.v1";

function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

function migrateLegacyPasskeyMap(): void {
  try {
    localStorage.removeItem(LEGACY_DEVICE_PASSKEY_STORAGE_KEY);
    const raw = localStorage.getItem(LEGACY_PASSKEY_BY_EMAIL_KEY);
    if (!raw) {
      return;
    }
    const parsed: unknown = JSON.parse(raw);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      const keys = Object.keys(parsed);
      const first = keys[0];
      if (first && !getLastLoginEmail()) {
        setLastLoginEmail(first);
      }
    }
    localStorage.removeItem(LEGACY_PASSKEY_BY_EMAIL_KEY);
  } catch {
    localStorage.removeItem(LEGACY_PASSKEY_BY_EMAIL_KEY);
    localStorage.removeItem(LEGACY_DEVICE_PASSKEY_STORAGE_KEY);
  }
}

let didMigrate = false;
function ensureMigrated(): void {
  if (didMigrate || typeof localStorage === "undefined") {
    return;
  }
  didMigrate = true;
  migrateLegacyPasskeyMap();
}

export function getLastLoginEmail(): string | null {
  ensureMigrated();
  try {
    const v = localStorage.getItem(LAST_LOGIN_EMAIL_STORAGE_KEY);
    return v && v.length > 0 ? normalizeEmail(v) : null;
  } catch {
    return null;
  }
}

export function setLastLoginEmail(email: string): void {
  ensureMigrated();
  try {
    const n = normalizeEmail(email);
    if (!n) {
      return;
    }
    localStorage.setItem(LAST_LOGIN_EMAIL_STORAGE_KEY, n);
  } catch {
    // ignore
  }
}
